export const mutations = {
  RESET: 'RESET',
  CHANGE_TAB: 'CHANGE_TAB',
  CHANGE_LAYOUT: 'CHANGE_LAYOUT',
  TOGGLE: 'TOGGLE',
  COMMIT_TEMPLATE_DATA: 'COMMIT_TEMPLATE_DATA',
  COMMIT_BLOCK_DATA: 'COMMIT_BLOCK_DATA',
  COMMIT_MYLIBRARY_DATA: 'COMMIT_MYLIBRARY_DATA',
  COMMIT_ELEMENT_DATA: 'COMMIT_ELEMENT_DATA',
  MUTATE_ELEMENT_ITEM: 'MUTATE_ELEMENT_ITEM',
  MUTATE_ELEMENT_ID: 'MUTATE_ELEMENT_ID',

  COMMIT_UPDATE_MYLIBRARY_ITEM: 'COMMIT_UPDATE_MYLIBRARY_ITEM',
  COMMIT_DELETE_MYLIBRARY_ITEM: 'COMMIT_DELETE_MYLIBRARY_ITEM',
  COMMIT_MYLIBRARY_SHARE_DATA: 'COMMIT_MYLIBRARY_SHARE_DATA',
  COMMIT_MYLIBRARY_LIB: 'COMMIT_MYLIBRARY_LIB',
  OPEN_CREATE_LIB: 'OPEN_CREATE_LIB',
  OPEN_ELEMENT_DETAIL: 'OPEN_ELEMENT_DETAIL',
  CLEAR_QUERIED_ITEMS: 'CLEAR_QUERIED_ITEMS',
  RESET_FETCHED_DATA: 'RESET_FETCHED_DATA',

  COMMIT_TEMPLATE_TAG_DATA: 'COMMIT_TEMPLATE_TAG_DATA',
  COMMIT_BLOCK_TAG_DATA: 'COMMIT_BLOCK_TAG_DATA',
  SYNC_FILTER_DATA: 'SYNC_FILTER_DATA',
  RESET_FILTER: 'RESET_FILTER',
  NUMBER_OF_USE_ADD_TO_PAGE: 'NUMBER_OF_USE_ADD_TO_PAGE',

  // new
  UPDATE_BLOCK_PERIOD: 'UPDATE_BLOCK_PERIOD',
  UPDATE_SHOW_ADD_TO_LIBRARY_ON_BOARDING: 'UPDATE_SHOW_ADD_TO_LIBRARY_ON_BOARDING',
  UPDATE_SHOW_SHARE_LIBRARY_ON_BOARDING: 'UPDATE_SHOW_SHARE_LIBRARY_ON_BOARDING',
  COMMIT_SAVED_LIBRARY_INFO: 'COMMIT_SAVED_LIBRARY_INFO',
};

export const actions = {
  GET_TEMPLATE_DATA: 'getTemplateData',
  GET_BLOCK_DATA: 'getBlockData',
  GET_MYLIBRARY_DATA: 'getMyLibraryData',
  GET_ELEMENT_DATA: 'getElementData',
  UNINSTALL_ELEMENT: 'uninstallElement',
  INSTALL_ELEMENT: 'installElement',
  UPDATE_ELEMENT: 'updateElement',

  GET_TEMPLATE: 'getTemplate',
  GET_BLOCK: 'getBlock',
  UPDATE_MYLIBRARY_ITEM: 'updateMyLibraryItem',
  DELETE_MYLIBRARY_ITEM: 'deleteMyLibraryItem',
  CHECK_MYLIBRARY_SHARE: 'checkMyLibraryShare',
  DO_SHARE_MYLIBRARY: 'doShareMyLibrary',
  CREATE_LIB: 'createLib',
  GET_COUNT_ADD_ON_LIBRARY: 'getCountAddOnLibrary',
};

export interface MyLibraryItemUpdate {
  demo?: string;
  description?: string;
  is_locked?: boolean;
  name?: string;
  owner?: boolean;
  share?: any;
  thumbnail?: string;
}

export class ElementStore {
  list: Array<any>;
  tags: Array<any>;
  categories: Array<any>;
  elementID: number | string | null;
  constructor() {
    this.list = [];
    this.tags = [];
    this.elementID = -1;
    this.categories = [];
  }
}

export class TemplateStore {
  list: Array<any>;
  filter: any;
  recommendTemplates: any;
  constructor() {
    this.list = [];
    this.filter = null;
  }
}

class LibraryShare {
  public stores: string[];
  public limit: number;
  public fetched: boolean;
  constructor() {
    this.stores = [];
    this.limit = 5;
    this.fetched = false;
  }
}

export class ExportData {
  public html: string;
  public bkHtml: string;
  public libs: any[];
  public fonts: any[];
  public script: string;
  public style: string;

  constructor() {
    this.html = '';
    this.bkHtml = '';
    this.libs = [];
    this.fonts = [];
    this.script = '';
    this.style = '';
  }
}

export class ExportType {
  public type: string;
  // public data: ExportData;
  public target: JQuery | undefined;
  constructor() {
    this.type = '';
    // this.data = new ExportData();
    this.target = undefined;
  }
}

export class MyLibraryStore {
  public list: Array<any>;
  public queriedList: Array<any>;
  public cachedSavedList: Array<any>;
  public allSaved: number;
  public allBlocks: number;
  public allTemplates: number;
  public shared: LibraryShare;
  public export: ExportType;
  public fetchedAll: boolean;
  public fetchedAllQuery: boolean;
  public hasMore: boolean;
  constructor() {
    this.list = [];
    this.queriedList = [];
    this.cachedSavedList = [];
    this.allSaved = 0;
    this.allBlocks = 0;
    this.allTemplates = 0;
    this.shared = new LibraryShare();
    this.export = new ExportType();
    this.fetchedAll = false;
    this.fetchedAllQuery = false;
    this.hasMore = false;
  }
}

export interface Tag {
  id: number;
  name: string;
  handle: string;
  children?: Tag[];
  count?: number;
}

export interface FilterObject {
  element: object;
  block: object;
  template: object;
  myLibrary: object;
}

export type TPeriod = {
  page: number;
  pageSize: number;
  refresh: boolean;
  loreMore: boolean;
  limited: boolean;
};
